module.exports = __webpack_public_path__ + "tabletSlideLeft.webp?fce6dd72ea1f9785dbc792d214087ce6";